import React from 'react';
import PropTypes from 'prop-types';
import ComingSoon from './ComingSoon';
import AssignmentsBasedGradingOptIn from './AssignmentsBasedGradingOptIn';

const BetaFeatures = ({
  active,
  displayAssignmentsBasedGradingOptIn,
  isAssignmentsBasedGradingActive,
  setIsAssignmentsBasedGradingActive,
  stafferPath
}) => {
  if (!active) return null;

  return (
    <>
      <ComingSoon displayNewsletter={!displayAssignmentsBasedGradingOptIn} />
      {displayAssignmentsBasedGradingOptIn && (
        <AssignmentsBasedGradingOptIn
          isAssignmentsBasedGradingActive={isAssignmentsBasedGradingActive}
          setIsAssignmentsBasedGradingActive={setIsAssignmentsBasedGradingActive}
          stafferPath={stafferPath}
        />
      )}
    </>
  );
};

BetaFeatures.propTypes = {
  active: PropTypes.bool.isRequired,
  displayAssignmentsBasedGradingOptIn: PropTypes.bool.isRequired,
  isAssignmentsBasedGradingActive: PropTypes.bool.isRequired,
  setIsAssignmentsBasedGradingActive: PropTypes.func.isRequired,
  stafferPath: PropTypes.string.isRequired,
};

export default BetaFeatures;
